import React from 'react'
import {Nav, Navbar, NavbarBrand, NavItem, NavbarToggler, Collapse} from "reactstrap";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import 'bootstrap/dist/css/bootstrap.css';
import './navigator.css';
import {get_version, x2xxPlats, x3xxPlats, x4xxPlats, _5xxxPlats} from "../../utes/appUtils";
import {getPinmuxToolVersion} from "../../utes/version";
import * as deviceConstants from '../../devices';

class Navigator extends React.Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.state = {
            modal: false,
            dropdownOpen:false,
            isOpen: false,
        };
        this.toggleModal = this.toggleModal.bind(this);
        this.toggleDropdownOpen = this.toggleDropdownOpen.bind(this);
    }

    toggleModal() {
        this.setState(prevState => ({
          modal: !prevState.modal
        }));
    }
    toggleDropdownOpen() {
        this.setState(prevState => ({
          dropdownOpen: !prevState.dropdownOpen
        }));
    }
    toggle() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }
    render() {
        let atmx2xx = Object.keys(deviceConstants.boardPinMap).filter((val) => {
            return x2xxPlats.includes(get_version(val))
        }).map((val) => {
            return (
                <option value={val}>{val}</option>
            );
        });

        let atmx3xx = Object.keys(deviceConstants.boardPinMap).filter((val) => {
            return x3xxPlats.includes(get_version(val))
        }).map((val) => {
            return (
                <option value={val}>{val}</option>
            );
        });

        let atmx4xx = Object.keys(deviceConstants.boardPinMap).filter((val) => {
            return x4xxPlats.includes(get_version(val))
        }).map((val) => {
            return (
                <option value={val}>{val}</option>
            );
        });

        let atm5xxx = Object.keys(deviceConstants.boardPinMap).filter((val) => {
            return _5xxxPlats.includes(get_version(val))
        }).map((val) => {
            return (
                <option value={val}>{val}</option>
            );
        });

        return (
            <Navbar className="pinmux-nav" color="light" light expand="md">
                <NavbarBrand className="nav-atmosic-logo">
                    <img src="./atmosic_logo.png" alt="Atmosic Technologies"/>
                </NavbarBrand>
                <NavbarToggler onClick={this.toggle} />
                <Collapse isOpen={this.state.isOpen} navbar>
                    <Nav navbar>
                        <NavItem>
                            <form onSubmit={this.handleSubmit}>
                                <label style={{paddingBottom: "5px"}} className="nav-link board-selector">
                                <span>
                                Product:
                                </span>
                                    <select className="selected-board" value={this.props.selectedBoard} onChange={this.props.boardCallback}>
                                        <optgroup label="ATMx2xx">
                                            {atmx2xx}
                                        </optgroup>
                                        <optgroup label="ATM33xx">
                                            {atmx3xx}
                                        </optgroup>
                                        <optgroup label="ATM34xx">
                                            {atmx4xx}
                                        </optgroup>
                                        <optgroup label="ATM5xxx">
                                            {atm5xxx}
                                        </optgroup>
                                    </select>
                                </label>
                            </form>
                            <span style={{padding: "5px", paddingBottom: "10px"}}>
                                Pinmux Tool {getPinmuxToolVersion()}
                            </span>
                        </NavItem>
                    </Nav>
                </Collapse>
                        <Modal isOpen={this.state.modal} toggle={this.toggleModal} className={this.props.className}>
          <ModalHeader toggle={this.toggleModal}>About PinMux Tool</ModalHeader>
          <ModalBody>
              <p style={{textAlign: 'center'}}>
                  Atmosic PinMux Tool<br></br>
                  <br></br>
                  Release: 0.0<br></br>
                  Requirements: Chrome 7+, Firefox 4+, Opera 11+, Safari 12+<br></br>
                  Copyright: 2019 Atmosic<br></br>
              </p>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.toggleModal}>Close</Button>
          </ModalFooter>
        </Modal>

            </Navbar>
        );
    }
}

export default Navigator;
